import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import Button from './../button/Button';
import PasswordField from './../form-field/PasswordField';
import Form from './../form-blocks/Form';

import { formSubmit, postSaveRestore, setInitialState } from './../../actions/auth-action'
import { passwordHandler } from './../../validators/form-validators';


class RestorePassword extends Component {
  state = {
    token: ''
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    this.props.setInitialState();
  }

  afterValidation() {
    if (this.props.isValidated) {
      const form = new FormData(this.refs.form.refs.form);
      const token = this.state.token;
      form.append('token', token);
      this.props.postSaveRestore(form);
    }
  }
  beforeFormSubmit() {
    this.props.formSubmit();
  }

  render() {
    let that = this;
    if (window.location.search === '') {
      browserHistory.push('/errors');
    } else {
      that.state.token = window.location.search.split('=')[1];
    }
    if (this.props.afterValidate) {
      this.afterValidation();
    }
    if (this.props.successSaveRestore) {
      setTimeout(() => {
        that.props.setInitialState();
        browserHistory.push('/auth');
      }, 5000);
    }

    let formContent = (
        <Form
          title='Восстановление пароля'
          ref='form'
          name='restoreRequestForm'
          successMessage={this.props.successMessage}
        >
          <div className='authorization__error'>{this.props.failMessage}</div>
          <div className='authorization__field'>
            <PasswordField
              title='Новый пароль' fieldName='password'
              errorHandler={passwordHandler}
            />
            <PasswordField
              title='Подтвердите пароль' fieldName='confirmedPassword'
              errorHandler={passwordHandler}
            />
          </div>
          <Button
            onClick={(e) => {
              e.preventDefault();
              this.beforeFormSubmit();
            }}
            styleClasses={['authorization__button']}
          >
            Сохранить
          </Button>
        </Form>
      );
    return (
      <div className='authorization'>
        {formContent}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isValidated: state.auth.isValidated,
  afterValidate: state.auth.afterValidate,
  failMessage: state.auth.failMessage,
  successMessage: state.auth.successMessage,
  successSaveRestore: state.auth.successSaveRestore,
});

const mapDispatchToProps = (dispatch) => ({
  formSubmit: bindActionCreators(formSubmit, dispatch),
  setInitialState: bindActionCreators(setInitialState, dispatch),
  postSaveRestore: bindActionCreators(postSaveRestore, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RestorePassword);



// WEBPACK FOOTER //
// ./src/blocks/restore-password/RestorePassword.js